"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSteeringWheel = function SvgIconSteeringWheel(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "steering wheel icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Steering Wheel Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.107 24.48c0-2.133 1.76-3.893 3.893-3.893s3.894 1.76 3.894 3.893-1.76 3.893-3.894 3.893a3.881 3.881 0 01-3.893-3.893M0 24C0 10.72 10.72 0 24 0s24 10.72 24 24-10.72 24-24 24S0 37.28 0 24m4.64 4.587c-.267 8.106 16 19.36 16 13.44 0-4.96-1.866-8.107-3.947-10.187-2.826-2.773-5.546-4.533-7.626-4.96-2.773-.64-4.374.693-4.427 1.707m-.16-8.533c-.107.96 1.867.853 3.093.693 3.84-.694 10.294-4 16.747-4 4.534 0 9.387 2.133 12.64 3.093 1.12.32 2.72.907 5.013 1.013.853.054 1.707-.16 1.654-.906C43.307 14.667 36.48 4.16 24 4.16c-9.493 0-18.773 7.947-19.52 15.893m38.987 8.534c-.054-1.014-1.653-2.4-4.427-1.76-2.026.48-4.8 2.186-7.627 5.013-2.08 2.08-3.946 5.227-3.946 10.187.053 5.92 16.267-5.334 16-13.44M18.4 24.48a5.6 5.6 0 1011.2 0 5.6 5.6 0 10-11.2 0"
  }));
};

var _default = SvgIconSteeringWheel;
exports.default = _default;